import Description from './primitives/Description';
import Ellipsis from './primitives/Ellipsis';
import Hero from './primitives/Hero';
import Truncate from 'components/Truncate';

export function formatDuration(duration = 0) {
  const hours = Math.floor(duration / 3600);
  const mins = Math.floor((duration - hours * 3600) / 60);
  const hrString = hours ? `${hours} hr` : '';

  return `${hrString} ${mins} min`;
}

type PLAYLISTHERODESCRIPTION = {
  description?: string;
  duration?: number;
  author?: string;
  hasUserInfo?: boolean;
  isRadio?: boolean;
};

export default function PlaylistHeroDescription({
  description,
  duration,
  author,
  hasUserInfo,
}: PLAYLISTHERODESCRIPTION) {
  let descriptionBody = null;

  if (hasUserInfo) {
    descriptionBody = (
      <>
        {`By ${author}`} <Hero>&bull;</Hero>
        {`${formatDuration(duration)}`}
      </>
    );
  }

  return (
    <div>
      <Description hideWhenSmallSize>
        <Truncate lines={2}>{description}</Truncate>
      </Description>
      <Description>
        <Ellipsis>{descriptionBody}</Ellipsis>
      </Description>
    </div>
  );
}
